/**
 * @desc: 静态下拉数据
 * @created: 2020/4/17
 * @author:yeungyifan
 * @version : v1.0
 */

// =================== 租赁
export const ShopCode = {
  0: '自有',
  1: '租赁'
}

// =================== 开通状态
export const OpenCode = {
  0: '开通',
  1: '关闭'
}

// =================== 业主性质
export const OwnerCode = {
  0: '个体',
  1: '商业'
}

// =================== 结算方式
export const SettleCode = {
  0: '日结',
  1: '周结',
  2: '月结'
}

// =================== 外卖
export const TakeawayCode = {
  0: '美团',
  1: '饿了么',
  3: '美团+饿了么'
}

// =================== 企业类型
export const typeList = [
  { value: '', label: '全部' },
  { value: '1', label: '商户' },
  { value: '2', label: '供应商' }
]

// =================== 是否公用
export const PublicCode = [
  { value: '', label: '全部' },
  { value: '0', label: '公用' },
  { value: '1', label: '非公用' }
]

// =================== 用户状态
export const stateAuditList = [
  { value: '', label: '全部' },
  { value: 1, label: '正常' },
  { value: 2, label: '未激活' },
  { value: 3, label: '黄名单' },
  { value: 4, label: '停用' },
  { value: 9, label: '风控执行永久停用(认为操作)' }
]

// =================== 餐饮类型
export const CateringType = [
  { value: '', label: '全部' },
  { value: 0, label: '旅游饭店' },
  { value: 1, label: '中餐厅' },
  { value: 2, label: '西餐厅' },
  { value: 3, label: '自助餐' },
  { value: 4, label: '快餐厅' },
  { value: 5, label: '大排档' },
  { value: 6, label: '茶饮店' },
  { value: 7, label: '烘焙店' }
]

// =================== 婚姻状况
export const MaritalStatus = [
  { value: '', label: '全部' },
  { value: 1, label: '未婚' },
  { value: 2, label: '已婚' },
  { value: 3, label: '离异' },
  { value: 4, label: '丧偶' },
  { value: 5, label: '其他' }
]

// =================== 住宅性质
export const Residential = [
  { value: '', label: '全部' },
  { value: 1, label: '亲属房产' },
  { value: 2, label: '租用' },
  { value: 3, label: '自由' },
  { value: 4, label: '其他' }
]

// =================== 教育程度
export const EducationLevel = [
  { value: '', label: '全部' },
  { value: 1, label: '博士及博士以上' },
  { value: 2, label: '硕士' },
  { value: 3, label: '本科' },
  { value: 4, label: '专科' },
  { value: 5, label: '高中' },
  { value: 6, label: '初中' },
  { value: 7, label: '小学' },
  { value: 8, label: '其他' }
]

// =================== 最高学位
export const HighestDegree = [
  { value: '', label: '全部' },
  { value: 1, label: '学士' },
  { value: 2, label: '硕士' },
  { value: 3, label: '博士' },
  { value: 4, label: '其他' }
]

// =================== 办理过贷款
export const HadLoan = [
  { value: '', label: '全部' },
  { value: 1, label: '是' },
  { value: 2, label: '否' }
]

// =================== 店铺性质
export const supNatureList = [
  { value: 0, label: '自有' },
  { value: 1, label: '租赁' }
]

// =================== 是否
export const isCode = [
  { value: '', label: '全部' },
  { value: '1', label: '是' },
  { value: '0', label: '否' }
]

// =================== 关系
export const relationshipList = [
  { value: '', label: '全部' },
  { value: '0', label: '父母' },
  { value: '1', label: '配偶' },
  { value: '2', label: '子女' },
  // { value: '3', label: '兄妹' },
  // { value: '4', label: '兄弟' },
  { value: '5', label: '同事' },
  { value: '6', label: '朋友' }
]

// =================== 直系亲属
export const directRelatives = [
  { value: '0', label: '父母' },
  { value: '1', label: '配偶' },
  { value: '2', label: '子女' }
]

// =================== 紧急联系人
export const urgentContact = [
  // { value: '3', label: '兄妹' },
  // { value: '4', label: '兄弟' },
  { value: '5', label: '同事' },
  { value: '6', label: '朋友' }
]

// =================== 业主性质
export const ownerNatureList = [
  { value: 0, label: '公家' },
  { value: 1, label: '私家' }
]

// =================== 审核状态
export const approvalStatusList = [
  { value: '', label: '全部' },
  { value: 0, label: '等待总部审核' },
  { value: 1, label: '总部通过(等待渠道审核' },
  { value: 2, label: '总部驳回' },
  { value: 3, label: '总部拒绝 ' },
  { value: 5, label: '渠道拒绝(无法重新申请)' },
  { value: 6, label: '冻渠道审核通过（等待发卡)结' },
  { value: 7, label: '转移发行' },
  { value: 8, label: '发卡-未激活' },
  // { value: 9, label: '发卡已激活（正常）' },
  { value: 12, label: '等待人工复核' },
  { value: 13, label: '人工复核有额度通过( 等待渠道审核） ' },
  { value: 14, label: '人工驳回' },
  { value: 15, label: '人工拒绝' },
  { value: 16, label: '人工复核无额度通过' },
  { value: 18, label: '无额度发行成功' },
  { value: 19, label: '额度激活中' },
  { value: 20, label: '激活失败' },

]

// =================== 供应商信息是否有更新
export const enterpriseIfUpdateList = [
  { value: '', label: '全部' },
  { value: 0, label: '正常' },
  { value: 1, label: '有提示' }
]

// =================== 评级
export const gradeList = [
  { value: '', label: '全部' },
  { value: '1', label: '低' },
  { value: '2', label: '中' },
  { value: '3', label: '高' }
]

// =================== 结算方式
export const settleMethodList = [
  { value: '', label: '全部' },
  { value: '0', label: '日结' },
  { value: '1', label: '周结' },
  { value: '2', label: '月结' }
]

// =================== 结算机构
export const settleCompanyList = [
  { value: '', label: '全部' },
  { value: '1', label: '总公司' },
  { value: '2', label: '分公司' }
]

// =================== 批复状态
export const auditStatusList = [
  { value: '', label: '全部' },
  { value: 'N1', label: '无' },
  { value: 'P1', label: '通过' },
  { value: 'W1', label: '待批复' },
  { value: 'K1', label: '拒绝' }
]

// =================== 人工复核
export const artificialAuditList = [
  { value: '', label: '全部' },
  { value: -1, label: '无' },
  { value: 1, label: '拒绝' },
  { value: 2, label: '驳回' },
  { value: 0, label: '有额度通过' },
  { value: 3, label: '无额度通过' },
  { value: 4, label: '等待人工复核' }
]

// =================== 要素不通过 / 重要提示
export const elementfailList = [
  { value: '', label: '全部' },
  { value: 0, label: '正常' },
  { value: -1, label: '无提示' },
  { value: 1, label: '身份证验证不通过' },
  { value: 2, label: '四要素验证不通过' },
  { value: 3, label: '营业时间验证不通过' },
  { value: 4, label: '经营范围验证不通过' },
  { value: 5, label: '店铺名称验证不通过' },
  { value: 6, label: '店铺面积验证不通过' },
  { value: 7, label: '有诉讼' },
  { value: 8, label: '评分不足' },
  { value: 99, label: '有提示' },
]

// 外卖平台
export const takeawayList = [
  { value: '0', label: '美团' },
  { value: '1', label: '饿了么' }
]

// 逾期阶段
export const overdueStageList = [
  { value: '', label: '全部' },
  { value: '0', label: '未逾期' },
  { value: '1', label: 'D10(逾期十天内)' },
  { value: '2', label: 'D20(逾期10-20天)' },
  { value: '3', label: 'D30(逾期20天以上)' }
]

// =================== 风控轴
export const riskAxis = [
  { value: '', label: '全部' },
  { value: 1, label: '时间类' },
  { value: 2, label: '金额类' },
  { value: 3, label: '波动类' },
  { value: 4, label: '地点类' },
  { value: 5, label: '对象类' },
  { value: 6, label: '其他' }
]

// =================== 风控坐标
export const riskCoord = [
  { value: -1, label: '全部' },
  { value: 1, label: '所有卡' },
  { value: 2, label: '所有POS' }
]

// =================== 风控运算符
export const riskOperator = [
  { value: -1, label: '全部' },
  { value: 1, label: '大于等于' },
  { value: 2, label: '区间' },
  { value: 3, label: '小于等于' },
  { value: 4, label: '等于' }
]

// =================== 风控周期类型
export const riskPeriod = [
  { value: -1, label: '全部' },
  { value: 0, label: '不限' },
  { value: 1, label: '周' },
  { value: 2, label: '月' },
  { value: 3, label: '半年' },
  { value: 4, label: '年' },
  { value: 5, label: '季' },
  { value: 6, label: '日' }
]

// 是否开通
export const isOpenList = [
  { value: '0', label: '开通' },
  { value: '1', label: '不开通' }
]

// 升/降
export const applyTypeList = [
  { value: '', label: '全部' },
  { value: '1', label: '提升额度' },
  { value: '2', label: '降低额度' }
]

// 额度调控 额度调整类型
export const quotaTypeList = [
  { value: '', label: '全部' },
  { value: '1', label: '平台申请' },
  { value: '2', label: '银行主动调整' }
]

// 支付标识
export const payTypeList = [
  { value: '', label: '全部' },
  { value: '1', label: '微信' },
  { value: '2', label: '支付宝' },
  { value: '3', label: '银联云闪付' },
  { value: '4', label: '京东' },
  { value: '5', label: 'POS机' }

]
// 计费方式
export const billingModeLisT = [
  { value: '', label: '全部' },
  { value: '1', label: '万分比' },
  { value: '2', label: '笔算' }
]

// 激活状态
export const activeTypeList = [
  { value: '', label: '全部' },
  { value: '19', label: '激活中' },
  { value: '8', label: '待激活' },
  { value: '20', label: '激活失败待重新激活' },
  // { value: '20', label: '续约待激活' },
  // { value: '20', label: '续约激活中' },
  // { value: '20', label: '续约激活失败待重新激活' }
]

// 受理复核
export const acceptanceReview = [
  { value: '', label: '全部' },
  { value: 0, label: '等待受理复核' },
  { value: 1, label: '通过' },
  { value: 2, label: '拒绝进件（待释放）' },
  { value: 3, label: '拒绝进件（已释放）' },
  { value: 4, label: '驳回申请' },
  { value: 5, label: '-' }
]





// 商户驳回申请
export const merOptions = [
  {
    value: 1,
    label: '基本信息',
    children: [
      {
        value: 'merName',
        label: '店铺名称'
      },
      {
        value: 'merAddress',
        label: '实际经营地址'
      },
      {
        value: 'restaurantType',
        label: '餐饮类型'
      },
      {
        value: 'merManageTime',
        label: '经营年限'
      },
      {
        value: 'merBusinesTime',
        label: '营业时间'
      },
      {
        value: 'merTurnoverAvg',
        label: '日营业额'
      },
      {
        value: 'merTableNum',
        label: '桌台数量'
      },
      {
        value: 'merFlow',
        label: '店铺客流'
      },
      {
        value: 'merSingleConsume',
        label: '人均消费'
      },
      {
        value: 'takeawayType',
        label: '外卖平台'
      },
      {
        value: 'merPhone',
        label: '外卖电话'
      },
      {
        value: 'employeeNum',
        label: '员工人数'
      },
      {
        value: 'merWages',
        label: '工资支出'
      },
      {
        value: 'merPurchase',
        label: '采购支出'
      },
      {
        value: 'merOther',
        label: '物业支出'
      },
      {
        value: 'merType',
        label: '店铺性质'
      },
      {
        value: 'merRent',
        label: '店铺租金'
      },
      {
        value: 'contractEndDate',
        label: '合同到期时间'
      },
    ]
  },
  {
    value: 2,
    label: '经营者信息',
    children: [
      {
        value: 'residential',
        label: '住宅性质'
      },
      {
        value: 'corpHomeAddr',
        label: '家庭住址'
      },
      {
        value: 'education',
        label: '教育程度'
      },
      {
        value: 'academic',
        label: '最高学位'
      },
      {
        value: 'marriage',
        label: '婚姻状况'
      },
      {
        value: 'loanNo',
        label: '办理过贷款'
      },

    ]
  },
  {
    value: 3,
    label: '紧急联系人',
    children: [
      {
        value: 'corpContactPeoplo1',
        label: '紧急联系人1'
      },
      // {
      //   value: 'corpContactRelation1',
      //   label: '关系1'
      // },
      // {
      //   value: 'corpContactPhone1',
      //   label: '联系电话1'
      // },
      {
        value: 'corpContactPeoplo2',
        label: '紧急联系人2'
      },
      // {
      //   value: 'corpContactRelation2',
      //   label: '关系2'
      // },
      // {
      //   value: 'corpContactPhone2',
      //   label: '联系电话2'
      // },
    ]
  },
  {
    value: 4,
    label: '资质查询',
    children: [
      {
        value: 'urlBusine',
        label: '营业执照'
      },
      {
        value: 'urlCardFront',
        label: '法人身份证（正面）'
      },
      {
        value: 'urlCardBack',
        label: '法人身份证（背面）'
      },
      {
        value: 'urlCashier',
        label: '收银台'
      },
      {
        value: 'urlDoor',
        label: '门头照'
      }, {
        value: 'urlShop',
        label: '店铺照片'
      }, {
        value: 'urlFacialFeature',
        label: '脸部特征'
      }, {
        value: 'urlSignature',
        label: '签字'
      },
    ]
  },
]

// 供应商驳回申请
export const supOptions = [
  {
    value: 1,
    label: '基本信息',
    children: [
      {
        value: 'turnoverAvg',
        label: '日营业额'
      },
      {
        value: 'space',
        label: '店铺面积'
      },
      {
        value: 'summary',
        label: '售卖概要'
      },
      {
        value: 'categoryName',
        label: '经营品类'
      },
      {
        value: 'isFamous',
        label: '知名企业'
      },
      {
        value: 'supIsChain',
        label: '是否连锁'
      },
      {
        value: 'openTime',
        label: '经营年限'
      },
      {
        value: 'supBusinessTime',
        label: '营业时间'
      },
      {
        value: 'supNature',
        label: '店铺性质'
      },
      {
        value: 'rent',
        label: '店铺租金'
      },
      {
        value: 'mccId',
        label: '行业类型'
      },
      {
        value: 'contractNo',
        label: '合同编号'
      },
      {
        value: 'contractEndDate',
        label: '合同到期'
      },
      {
        value: 'description',
        label: '备注信息'
      },

    ]
  },
  // {
  //   value: 2,
  //   label: '经营者信息',
  //   children: [
  //     {
  //       value: 'homeAddr',
  //       label: '家庭住址'
  //     },


  //   ]
  // },
  {
    value: 3,
    label: '紧急联系人',
    children: [
      {
        value: 'iceOneName',
        label: '紧急联系人1'
      },
      // {
      //   value: 'iceOneRelation',
      //   label: '关系1'
      // },
      // {
      //   value: 'iceOnePhone',
      //   label: '联系电话1'
      // },
      {
        value: 'iceTwoName',
        label: '紧急联系人2'
      },
      // {
      //   value: 'iceTwoRelation',
      //   label: '关系2'
      // },
      // {
      //   value: 'iceTwoPhone',
      //   label: '联系电话2'
      // },
    ]
  },
  {
    value: 4,
    label: '资质查询',
    children: [
      {
        value: 'licensePhotoUrl',
        label: '营业执照'
      },
      {
        value: 'urlCardFront',
        label: '法人身份证（正面）'
      },
      {
        value: 'urlCardBack',
        label: '法人身份证（背面）'
      },
      {
        value: 'urlCashier',
        label: '收银台'
      },
      {
        value: 'doorPhotoUrl',
        label: '门头照'
      },
      {
        value: 'officePhotoUrl',
        label: '店铺照片'
      },
      {
        value: 'urlFacialFeature',
        label: '脸部特征'
      },
      {
        value: 'urlSignature',
        label: '签字'
      },
      {
        value: 'urlCorpMandate',
        label: '委托授权书'
      },
    ]
  },
]


// 线索转化拒绝理由
export const denialReason = [
  {
    value: 'A：来源',
    label: 'A：来源',
    children: [
      {
        value: 'A1：网络',
        label: 'A1：网络'
      },
      {
        value: 'A2：地推',
        label: 'A2：地推'
      }
    ]
  },
  {
    value: 'B：拜访',
    label: 'B：拜访',
    children: [
      {
        value: 'BN1：老板不在',
        label: 'BN1：老板不在'
      },
      {
        value: 'BN2：没兴趣',
        label: 'BN2：没兴趣',
        children: [
          {
            value: 'BN2-1：已有信用卡支撑',
            label: 'BN2-1：已有信用卡支撑'
          },
          {
            value: 'BN2-2：老板年龄大，不接受',
            label: 'BN2-2：老板年龄大，不接受'
          },
          {
            value: 'BN2-3：交易方式为月结',
            label: 'BN2-3：交易方式为月结'
          },
          {
            value: 'BN2-4：交易方式为现金结算',
            label: 'BN2-4：交易方式为现金结算'
          }
        ]
      },
      {
        value: 'BN3：时间点不适合',
        label: 'BN3：时间点不适合',
        children: [
          {
            value: 'BN3-1：店里正忙',
            label: 'BN3-1：店里正忙'
          },
          {
            value: 'BN3-2：宵夜店',
            label: 'BN3-2：宵夜店'
          }
        ]
      },
      {
        value: 'BN4：抵触任何业务推广',
        label: 'BN4：抵触任何业务推广'
      },
      {
        value: 'BN5：其他',
        label: 'BN5：其他'
      }
    ]
  },
  {
    value: 'C：沟通',
    label: 'C：沟通',
    children: [
      {
        value: 'CN1：额度小',
        label: 'CN1：额度小'
      },
      {
        value: 'CN2：客户觉得供应链资源不足',
        label: 'CN2：客户觉得供应链资源不足'
      },
      {
        value: 'CN3：产品信任度低',
        label: 'CN3：产品信任度低',
        children: [
          { value: 'CN3-1：抵触贷款类APP', label: 'CN3-1：抵触贷款类APP' },
          {
            value: 'CN3-2：担心泄漏个人信息',
            label: 'CN3-2：担心泄漏个人信息'
          },
          { value: 'CN3-3：担心诈骗', label: 'CN3-3：担心诈骗' },
          { value: 'CN3-4：产品知名度低', label: 'CN3-4：产品知名度低' }
        ]
      },
      {
        value: 'CN4：产品吸引力低',
        label: 'CN4：产品吸引力低',
        children: [
          { value: 'CN4-1：无实际优惠', label: 'CN4-1：无实际优惠' },
          { value: 'CN4-2：无附赠礼品', label: 'CN4-2：无附赠礼品' }
        ]
      },
      {
        value: 'CN5：批复额度使用范围小',
        label: 'CN5：批复额度使用范围小'
      },
      {
        value: 'CN6：沟通过程中被外界人事打扰打断',
        label: 'CN6：沟通过程中被外界人事打扰打断'
      },
      {
        value: 'CN7：其他',
        label: 'CN7：其他'
      }
    ]
  },
  {
    value: 'D：进件',
    label: 'D：进件',
    children: [
      {
        value: 'DN1：进件资料不全',
        label: 'DN1：进件资料不全',
        children: [
          {
            value: 'DN1-1：缺少身份证/银行卡',
            label: 'DN1-1：缺少身份证/银行卡'
          },
          {
            value: 'DN1-2：缺少交易流水账单',
            label: 'DN1-2：缺少交易流水账单'
          }
        ]
      },
      {
        value: 'DN2：个人信息采集过多，客户不同意',
        label: 'DN2：个人信息采集过多，客户不同意'
      },
      {
        value: 'DN3：进件过程中被外界人事干扰打断',
        label: 'DN3：进件过程中被外界人事干扰打断'
      },
      ,
      {
        value: 'DN4：突然返回，不想进件',
        label: 'DN4：突然返回，不想进件'
      },
      ,
      {
        value: 'DN5：主事人不是法人且不在现场无法做最终决定',
        label: 'DN5：主事人不是法人且不在现场无法做最终决定'
      },
      ,
      {
        value: 'DN6：APP出现问题，无法进件',
        label: 'DN6：APP出现问题，无法进件'
      },
      ,
      {
        value: 'DN7：其他',
        label: 'DN7：其他'
      }
    ]
  }
]